import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export type Loading = 'hidden' | 'pending' | 'succeeded' | 'failed';


interface ui {
    loading: Loading
}

const initialState: ui = {
    loading: "hidden"
}

const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        setLoading: (state, action: PayloadAction<ui['loading']>) => {
            state.loading = action.payload;
        },
    }
})

export const uiSlicedActions = uiSlice.actions;

export default uiSlice;